"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.PromocodeSubmissionSource=void 0;var o;(function(e){e.Checkout="Checkout",e.Deeplink="Deeplink",e.PromocodesList="PromocodesList"})(o||(exports.PromocodeSubmissionSource=o={}));
//# sourceMappingURL=PromocodeSubmissionSource.js.map
